import { randomNumber } from '../../../../utilities'
import { AssessmentConstants } from './assessment.constant'
import { IAssessmentAction, IAssessmentState } from './assessment.types'

export const initialAssessmentProcedureState: IAssessmentState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  pta: false,
  successfulAttempt: true,
  attempts: '1',
  assessedBy: null,
  rolePerforming: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  action: null,
  gaze: null,
  facialSymmetry: null,
  speech: null,
  limbMotorStrength: null,
  limbSensation: null,
  suspectedInfection: null,
  sepsisIndicators: [],
  procedureComplications: [],
  possibleSourceOfInfection: '',
  customAssessmentsFields: [],
  _hideNeuroFields: true,
  _hideSepsisFields: true,
  response: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  type: 'Assessments',
  nemsisCode: null,
  isEkgImport: null,
  _customFieldOption: null,
}
export function assessmentReducer(
  state: IAssessmentState = initialAssessmentProcedureState,
  action: IAssessmentAction
): IAssessmentState {
  switch (action.type) {
    case AssessmentConstants.SET_DATE:
      return { ...state, date: action.date }
    case AssessmentConstants.SET_TIME:
      return { ...state, time: action.time }
    case AssessmentConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case AssessmentConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case AssessmentConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case AssessmentConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case AssessmentConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case AssessmentConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case AssessmentConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case AssessmentConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case AssessmentConstants.SET_ACTION:
      return { ...state, action: action.action }
    case AssessmentConstants.SET_GAZE:
      return { ...state, gaze: action.gaze }
    case AssessmentConstants.SET_FACIAL_SYMMETRY:
      return { ...state, facialSymmetry: action.facialSymmetry }
    case AssessmentConstants.SET_SPEECH:
      return { ...state, speech: action.speech }
    case AssessmentConstants.SET_LIMB_MOTOR_STRENGTH:
      return { ...state, limbMotorStrength: action.limbMotorStrength }
    case AssessmentConstants.SET_LIMB_SENSATION:
      return { ...state, limbSensation: action.limbSensation }
    case AssessmentConstants.SET_SUSPECTED_INFECTION:
      return { ...state, suspectedInfection: action.suspectedInfection }
    case AssessmentConstants.SET_SEPSIS_INDICATORS:
      return { ...state, sepsisIndicators: action.sepsisIndicators }
    case AssessmentConstants.SET_POSSIBLE_SOURCE_OF_INFECTION:
      return { ...state, possibleSourceOfInfection: action.possibleSourceOfInfection }
    case AssessmentConstants.SET_CUSTOM_ASSESSMENTS_FIELDS:
      return { ...state, customAssessmentsFields: action.customAssessmentsFields }
    case AssessmentConstants.SET_CUSTOM_FIELD_OPTION:
      return {
        ...state,
        _customFieldOption: {
          value: action._customFieldOption,
          fieldId: action.fieldId,
          fieldType: action.fieldType,
          responseType: action.responseType,
        },
      }
    case AssessmentConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case AssessmentConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case AssessmentConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case AssessmentConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case AssessmentConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case AssessmentConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case AssessmentConstants.SET_STATE:
      return { ...action.assessment, updateInputRows: true }
    case AssessmentConstants.SET_HIDE_NEURO_FIELDS:
      return { ...state, _hideNeuroFields: action._hideNeuroFields }
    case AssessmentConstants.SET_HIDE_SEPSIS_FIELDS:
      return { ...state, _hideSepsisFields: action._hideSepsisFields }
    case AssessmentConstants.CLEAR_FIELDS:
      return {
        ...state,
        gaze: null,
        facialSymmetry: null,
        speech: null,
        limbMotorStrength: null,
        limbSensation: null,
        suspectedInfection: null,
        sepsisIndicators: [],
        procedureComplications: [],
        possibleSourceOfInfection: '',
        customAssessmentsFields: [],
        _customFieldOption: null,
        type: 'Assessments',
        nemsisCode: null,
      }

    case AssessmentConstants.RESET_STATE:
      return {
        ...initialAssessmentProcedureState,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        key: randomNumber().toString(),
      }
    default:
      return state
  }
}
